export const getters = {
  teamMembers(state) {
    return state.team.members;
  },
};
